import { render } from "./ApiDocsPlugin.vue?vue&type=template&id=2d01bee8"
import script from "./ApiDocsPlugin.vue?vue&type=script&lang=js"
export * from "./ApiDocsPlugin.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__